import React from 'react';
import {Link} from 'react-router-dom'

export default function CreateButton({ reference, url }) {
    return(
        <Link to={`/${url}/${reference.push().key}`} className="btn-group-vertical btn-info py-2 px-4 mb-4">NUEVA ENTRADA</Link>
    )
}



// WEBPACK FOOTER //
// ./src/admin/components/editor/CreateButton.js